

import dao from './BaseDao'

export default {
  // demo(data){    // 获得左侧菜单       
  // 	return dao.post('/v1.0/api/get_subjects/',data)
  // },
  login(data){  //登入
    // return dao.post('/api/login/',data);
    // return dao.postf('cd/users/mylogin/',data);
    // return dao.postf('/user/user-login/',data);
  },
  getsearchdata(data){    // 查询获取文档列表      
  	return dao.post1('/api/FileCenter/List/',data)
  },
  getmycollection(){  //获取我的收藏页面
    return dao.post1('/api/FileCenter/Collection/')
  },
  collectionbyid(data){ //收藏或取消收藏文档
    return dao.post1('/api/FileCenter/Collect/',data)
  },
  getdetailed(id){  //获取文档详情
    return dao.post1('/api/FileCenter/Detail/',{id:id})
  },
  getrelevant(data){  //获取文档相关文档
    return dao.post1('',data)
  },
  adddemand(data){  //提交需求
    return dao.post1('',data)
  },
  getalltype(){  //获取文档类型
    return dao.post('/api/FileType/List/')
  },
  gethelppage(id){ //获取页面信息
    return dao.post1('/api/help/getProject/',{id:id})
  },
  getpagecontent(data){
    return dao.post1('/api/help/getContent/',data)
  }
}



// WEBPACK FOOTER //
// ./src/service/demoService.js